
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {AccountService} from "../../services";
import {environment} from "../../../../environments/environment";
import {SellingReportList} from "../../models/sellingReportList";
import {TopSellerList} from "../../models/topSellerList";
import {Product} from "../../models/product";
import {SellingReport} from "../../models/sellingReport";
import {SellingReportItem} from "../../models/sellingReportItem";
import {CommissionReportItems} from "../models/commissionReportList";



@Injectable({ providedIn: 'root' })
export class CommissionReportService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    get(createdAt, createdAtTo, type?: string) {
        const requestBody: any = {
            'createdAt': createdAt,
            'createdAtTo': createdAtTo
        };

        if (type && type !== 'ALL') {
            requestBody.type = type;
        }

        return this.http.post(`${environment.apiEndpoint}/v1/reports/commission`, requestBody, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: CommissionReportItems) => {
                return x;
            }));
    }
}
